/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  display: grid;
  grid-gap: 1rem;
  min-height: 100%;
  height: 100%;
  box-sizing: border-box;
  justify-content: stretch;
  align-content: stretch;
  font-size: 1rem;
}
:host #MID {
  align-self: stretch;
  justify-self: stretch;
  overflow: hidden;
  position: relative;
}
:host #MID ::slotted(*) {
  width: 100%;
  height: 100%;
}

:host([placement=N]) {
  grid-template-columns: inherit;
  grid-template-rows: -webkit-min-content auto;
  grid-template-rows: min-content auto;
}

:host([placement=S]) {
  grid-template-columns: inherit;
  grid-template-rows: auto -webkit-min-content;
  grid-template-rows: auto min-content;
}

:host([placement="N&S"]) {
  grid-template-columns: inherit;
  grid-template-rows: -webkit-min-content auto -webkit-min-content;
  grid-template-rows: min-content auto min-content;
}

:host([placement=NW]) {
  grid-template-columns: -webkit-min-content auto;
  grid-template-columns: min-content auto;
  grid-template-rows: auto;
}
:host([placement=NW]) #NW {
  align-self: start;
}

:host([placement=W]) {
  grid-template-columns: -webkit-min-content auto;
  grid-template-columns: min-content auto;
  grid-template-rows: auto;
}
:host([placement=W]) #W {
  align-self: center;
}

:host([placement=SW]) {
  grid-template-columns: -webkit-min-content auto;
  grid-template-columns: min-content auto;
  grid-template-rows: auto;
}
:host([placement=SW]) #SW {
  align-self: end;
}

:host([placement=NE]) {
  grid-template-columns: auto -webkit-min-content;
  grid-template-columns: auto min-content;
  grid-template-rows: auto;
}
:host([placement=NE]) #NE {
  align-self: start;
}

:host([placement=E]) {
  grid-template-columns: auto -webkit-min-content;
  grid-template-columns: auto min-content;
  grid-template-rows: auto;
}
:host([placement=E]) #E {
  align-self: center;
}

:host([placement=SE]) {
  grid-template-columns: auto -webkit-min-content;
  grid-template-columns: auto min-content;
  grid-template-rows: auto;
}
:host([placement=SE]) #SE {
  align-self: end;
}

:host([hidden]) {
  display: none;
}

.placeholder {
  flex-grow: 1;
}`;
export { style };
